import { spreadSearchQuery } from "helpers/utilities"
import { get, put, post, del } from "../api_helper2"
import { get as getWithoutError} from "../api_helper_withoutError"

const BASE_API_URL = `${process.env.REACT_APP_BFF_ENDPOINT}/msdashboard`

const GetAllSetting = payload => {
  let q = spreadSearchQuery(payload)

  return getWithoutError(`${BASE_API_URL}?${q}`)
}
export {
  GetAllSetting
}